(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/components/tabs-url/assets/javascripts/tabs-plugin.js') >= 0) return;  svs.modules.push('/components/components/tabs-url/assets/javascripts/tabs-plugin.js'); 'use strict';

var svs = svs || {};
svs.components = svs.components || {};

svs.components.tabPlugins = svs.components.tabPlugins || {};

svs.components.tabPlugins.url = function(options) {
  var userSpecifiedPathInvalid = false,
    startIndex = 0,
    self = this;

  function init() {
    if (options.selected) {
      startIndex = getTabIndexByUrl(options.selected);
    }

    userSpecifiedPathInvalid = startIndex < 0;

    if (userSpecifiedPathInvalid || !options.selected) {
      startIndex = getTabIndexByUrl(options.defaultTab);
    }

    if (startIndex < 0) {
      startIndex = 0;
    }

    options.startIndex = startIndex;

    if (userSpecifiedPathInvalid) {
      updateUrl(options.tabs[startIndex].id);
    }

    self.on('change', function(tab) {
      updateUrl(tab.tab.id);
    });

    $(window.document).on('removeTab', function(event, tabUrl) {
      removeTab(tabUrl);
    });
  }

  function getTabIndexByUrl(tabUrl) {
    if ((options || {}).tabs) {
      var selectedTab = _.find(options.tabs, function(tab) {
        return tab.id === tabUrl;
      });

      if (!selectedTab) {
        selectedTab = _.find(options.tabs, function(tab) {
          return (
            tab &&
            tab.caption &&
            tab.caption.toLowerCase() === (tabUrl && tabUrl.toLowerCase())
          );
        });
      }

      return _.indexOf(options.tabs, selectedTab);
    }
    return -1;

  }

  function removeTab(tabUrl) {
    var index = getTabIndexByUrl(tabUrl);
    if (!!index || index === 0) {
      if (index > -1) {
        options.tabs.splice(index, 1);

        self.tabsSlider.remove(index);
        self.contentSlider.remove(index);
      }
    }
  }

  function makePath(fragment, newId) {
    var path = endsWith(fragment, '/')
      ? fragment.substring(0, fragment.length - 1)
      : fragment;
    var query = window.location.search || '';
    if (userSpecifiedPathInvalid || query !== '') {
      userSpecifiedPathInvalid = false;
      if (path.indexOf('?') > 0) {
        query = path.substring(path.lastIndexOf('?'));
        path = path.substring(0, path.lastIndexOf('?'));
      } else {
        path = path.substring(0, path.lastIndexOf('/'));
      }
    } else {
      path =
        path.indexOf('?') > 0 ? path.substring(0, path.lastIndexOf('?')) : path;
    }

    _.each(options.tabs, function(tab) {
      if (tab.id) {
        if (endsWith(path, tab.id)) {
          path = path.substring(0, path.length - tab.id.length);
        }
      }
    });

    if (options.defaultTab !== newId) {
      if (!endsWith(path, '/')) path += '/';
      path += newId;
    }

    if (query.length > 0) {
      path = endsWith(path, '/') ? path.substring(0, path.length - 1) : path;
      path += query;
    }
    return path;
  }

  function endsWith(str, suffix) {
    return str.indexOf(suffix, str.length - suffix.length) !== -1;
  }

  function updateUrl(id) {
    if (options.path) {
      var path;
      if (Object.prototype.hasOwnProperty.call(Backbone.history, 'fragment')) {
        path = makePath(Backbone.history.fragment, id);

        Backbone.history.navigate(path, { trigger: false, replace: true });
      } else if (window.History && svs && svs.tips_sm && svs.tips_sm.history) {
        path = makePath('', id);
        svs.tips_sm.history.replace(path);
      }
    }
  }

  init();
};

 })(window);